import { render, staticRenderFns } from "./SuccessfulPage.vue?vue&type=template&id=14ff8320&"
import script from "./SuccessfulPage.vue?vue&type=script&lang=js&"
export * from "./SuccessfulPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports